//export const baseURL = "http://localhost:5000";
export const baseURL = "https://eabcapi-production.up.railway.app";
//export const APIKey = "43025cc3-b899-47b5-be7e-e3538723db14";
